import { type FC } from "react";

import { type LensStatusDisplayMeta } from "../../state";

import { LensStatusIndicator, LensesStatusTitle } from "./LensStatus.styles";

interface LensStatusProps {
    lensStatusDisplayMeta: LensStatusDisplayMeta;
}

export const LensStatusBadge: FC<LensStatusProps> = ({ lensStatusDisplayMeta: { name, color } }) => {
    return (
        <LensesStatusTitle>
            <LensStatusIndicator background={color} />
            {name}
        </LensesStatusTitle>
    );
};
